import React, {useState} from "react";
import { makeStyles } from '@material-ui/core/styles';
import {
  Stepper,
  Step,
  StepLabel,
} from '@material-ui/core';
import {connect} from "react-redux";
import {actions} from "../../../../redux/modules/auth/actions";
import {Step1, Step2} from "../../../components/modules/Registration";
import {register} from "../../../../redux/modules/auth/crud";

const initialValues = {
  // step1
  adminId: '',
  password: '',
  passwordConfirm: '',
  telNo: '',
  authNo: '',
  email: '',

  // step2
  bsnOprName: '',
  bsnLicNum: '',
  zipCode: '',
  addr: '',
  dtlAddr: '',
  csTelNo: '',
  bsnLicImgUrl: '',

  // step3
  relZipCode: '',
  relAddr: '',
  relDtlAddr: '',
  retZipCode: '',
  retAddr: '',
  retDtlAddr: '',
  bankCd: '',
  accNum: '',
  dpstStkNm: '',
};

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  stepLabel: {
    fontSize: 14,
  },
  backButton: {
    marginRight: theme.spacing(1),
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
}));

function getSteps() {
  return [
    '기본 정보 등록',
    '정산 정보 등록',
  ];
}

function Registration({ history }) {
  const classes = useStyles();
  const steps = getSteps();

  const [registFormData, setRegistFormData] = useState(initialValues);
  const [activeStep, setActiveStep] = useState(0);

  const handleNext = (values) => {
    setRegistFormData(prevState => ({...prevState, ...values}));
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };
  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleSubmit = (values) => {
    setRegistFormData(prevState => ({...prevState, ...values}));
    register(values).then(() => {
      alert('판매파트너 회원가입 신청이 완료 되었습니다.');
      history.push('/login');
    }).catch(err => {
      alert(err.message);
    });
  };

  return (
    <div className="login-form login-signin" style={{display: "block", maxWidth: 500}}>
      <div className="text-center mb-10 mb-lg-20">
        <h3 className="font-size-h1">룰루 판매파트너 회원가입 신청</h3>
      </div>

      <Stepper activeStep={activeStep} alternativeLabel>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel classes={{label: classes.stepLabel}}>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>

      <div>
        {activeStep === 0 && (
          <Step1
            initValues={registFormData}
            goNext={handleNext}
          />
        )}
        {activeStep === 1 && (
          <Step2
            initValues={registFormData}
            goBack={handleBack}
            onSubmit={handleSubmit}
          />
        )}
      </div>
    </div>
  );
}

export default connect(null, actions)(Registration);
